import React, { Component } from 'react';
import $ from 'jquery';
import Vas from '../../Vas';
import '../../css/Contracts.css';
import ReactDOM from 'react-dom';
import { PagingTable,Loading,MessageBox } from 'component-lib';

import { RoleConfiguration,DateTimeHelper } from 'utils-lib';

import { RequestAjaxClass, ContractsModel, PaymentsModel } from 'models-lib';

var sendString = "";

class Contracts extends Component{

    constructor(props)
    {
        super(props);
        this.state = {};
        this.state.Limit = 10;
        this.state.Start = 0;
        this.state.Id = "";
        this.role = localStorage.getItem("vas_role");
        this.CustomerId = localStorage.getItem("vas_customerId");
        this.state.all = props.match.params.all;
        this.state.ready = false;
        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
        this.ContractsModel = new ContractsModel([this]);
        this.PaymentsModel = new PaymentsModel([this]);
    }

    componentWillMount(){
        this.Request.setApiUrl(Vas.ApiUrl);
        this.Request.setApiKey(Vas.ApiKey);
        this.Request.setAuth(true);
        this.Request.setErrorHandler(()=>{
            ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer'));
        });
        this.ContractsModel.SetRequest(this.Request);
        this.PaymentsModel.SetRequest(this.Request);
        ReactDOM.render(<Loading modal={true} />,document.getElementById('popupContainer'));
    }

    componentDidMount()
    {
        this.setState({ ready:true },()=>{
            this.setPagingStates();
        });
        
        if(this.state.all === "true"){
            $("#HeaderTitle").html(Vas.Resources.Labels["Contracts"]);
        } else {
            $("#HeaderTitle").html(Vas.Resources.Labels["Tasks"]);
        }
    }

    componentDidUpdate(){
        if (this.state.all !== this.props.match.params.all){
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ all:this.props.match.params.all },()=>{
                this.setPagingStates();
            });
        }
    }

    Update(observer){
        let me = this;
        this.setState({},()=>{
            if(observer === "Contracts"){
                let items = this.ContractsModel.Contracts;
                let contracts = [];
                let counter = 0;
                if (items)
                {
                    let sendStringArray = [];
                         if(sendString !== ""){
                             sendStringArray = sendString.split('&');
                         }

                    items.forEach(function(value) {
                        let contract = {};

                        contract = value;
                        contract.DateFrom = DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(value.DateFrom,true,localStorage.getItem('vas_language')));
                        contract.DateTo =  value.DateTo<value.DateFrom ? "" : DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(value.DateTo,true,localStorage.getItem('vas_language')));                       
                        
                        if (value.StatusId === 10){
                            contract.Status=Vas.Resources.Labels["PendingApproval"];
                        } else {
                            contract.Status=value.Status; 
                        }

                        if(sendStringArray.length >= 3){
                            var searchParamArray = sendStringArray[2].split ('=');

                            if(sendStringArray.length == 4){
                                searchParamArray = sendStringArray[3].split ('=');
                            }

                            switch (searchParamArray[0]) {
                                case "StatusId":
                                    contracts.push(contract);
                                    counter++;
                                    break;
                                case "ContractNumber":
                                    if(contract.ContractNumber.indexOf(searchParamArray[1]) > -1){
                                        contracts.push(contract);
                                        counter++;
                                    }
                                    break;
                                case "CustomerName":
                                    if(contract.CustomerName.toLowerCase().indexOf(searchParamArray[1].toLowerCase()) > -1){
                                        contracts.push(contract);
                                        counter++;
                                    }
                                    break;
                                case "TicketName":
                                    if(contract.TicketName.indexOf(searchParamArray[1]) > -1){
                                        contracts.push(contract);
                                        counter++;
                                    }
                                    break;
                                case "DateFrom":
                                    if(contract.DateFrom.indexOf(searchParamArray[1]) > -1){
                                        contracts.push(contract);
                                        counter++;
                                    }
                                    break;
                                case "DateTo":
                                    if(contract.DateTo.indexOf(searchParamArray[1]) > -1){
                                        contracts.push(contract);
                                        counter++;
                                    }
                                    break;
                                case "CustomerAbove":
                                    if(contract.CustomerAbove.indexOf(searchParamArray[1]) > -1){
                                        contracts.push(contract);
                                        counter++;
                                    }
                                    break;
                                case "Street":
                                    if(contract.Street.indexOf(searchParamArray[1]) > -1){
                                        contracts.push(contract);
                                        counter++;
                                    }
                                    break;
                                case "HouseNumber":
                                    if(contract.HouseNumber.indexOf(searchParamArray[1]) > -1){
                                        contracts.push(contract);
                                        counter++;
                                    }
                                    break;
                                case "HouseNumberAddition":
                                    if(contract.HouseNumberAddition.indexOf(searchParamArray[1]) > -1){
                                        contracts.push(contract);
                                        counter++;
                                    }
                                    break;
                                case "City":
                                    if(contract.City.indexOf(searchParamArray[1]) > -1){
                                        contracts.push(contract);
                                        counter++;
                                    }
                                    break;
                                case "Zip":
                                    if(contract.PostCode.indexOf(searchParamArray[1]) > -1){
                                        contracts.push(contract);
                                        counter++;
                                    }
                                    break;
                            }
                        
                        } else {
                            contracts.push(contract);
                        }
                    });
                    
                    localStorage.setItem('csvDataContent',JSON.stringify(contracts));
                }

                $("#LoadingIcon").removeClass().addClass('hide');

                let count = counter;
                if(this.ContractsModel.Limit !== 9999){
                    count = this.ContractsModel.Count;
                }

                if (me.refs.table){
                    me.refs.table.setState({ Data: contracts, Start: this.ContractsModel.Start, End: this.ContractsModel.Start+contracts.length, Limit: this.ContractsModel.Limit, Count: count });
                }
                ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer'));
            }
            else if(observer === "Payment"){
                if (this.PaymentsModel.Count !== null && this.PaymentsModel.Count !== undefined) {
                    let count = this.PaymentsModel.Count;
                    if (count > 0) {
                        let valid = false;
                        for (let i = 0; i< count; i++){
                            if (this.PaymentsModel.Payments[i].PaymentMethodValue === 4){
                                valid = true;
                                break;
                            }
                        }
                        if (valid === true){
                            Vas.GetView('CreateContract', { CustomerId:me.CustomerId }, true);
                        } else {
                            Vas.GetView('NoPayment',{ CustomerId:me.CustomerId },true);
                        }
                    } else {
                        Vas.GetView('NoPayment',{ CustomerId:me.CustomerId },true);
                    }
                }
            }
            else if(observer === "ContractsChangeBulk"){
                ReactDOM.render(<MessageBox 
                    AppURL={Vas.ApplicationUrl}
                    Message={Vas.Resources.Labels["MultibleApprove"]}
                    Title={Vas.Resources.Titles["Note"]} />, document.getElementById('messageContainer'));   
                $("#LoadingIcon").removeClass().addClass('hide');
                me.load(me.refs.table.PrepareSendData());
            }
        });
    }

    loadContract(id){
        let me = this;
        let customerId = "";
        let customerName = "";

        for (let i = 0; i < me.refs.table.state.Data.length; i++)
        {
            if (me.refs.table.state.Data[i].Id === id)
            {
                customerId = me.refs.table.state.Data[i].IdCustomer;
                customerName = me.refs.table.state.Data[i].CustomerName;
                break;
            }
        }
        Vas.GetView("ContractCardContractData",{ Id:id, CustomerId: customerId, CustomerName: customerName },true);
    }

    setPagingStates(){
        if (this.role === '1'){
            this.refs.table.setState({
                Width:800,
                SearchParams:[{ Parameter: 'StatusId', SearchValue: 1 }],
                columns:[Vas.Resources.Labels["ContractNumber"],
                        Vas.Resources.Labels["Customer"] ,
                        Vas.Resources.Labels["State"], 
                        Vas.Resources.Labels["Product"],
                        Vas.Resources.Labels["Start"],
                        Vas.Resources.Labels["End"],
                        Vas.Resources.Labels["Action"] ], 
                keys:["ContractNumber", 
                        "CustomerName", 
                        "Status",
                        "TicketName", 
                        "DateFrom",
                        "DateTo"],
                Add:true,
                AddClick:()=>{this.AddContract();},
                CWidth:[110,120,80,120,100,100,50],
                Filter:true,
                Action:false,
                Search:true
            },()=>{
                this.load(this.refs.table.PrepareSendData());
            });
        } else if (this.role === "3" || this.role === "99"){
            if (this.state.all === 'true'){
                this.refs.table.setState({
                    SearchParams:[{ Parameter: 'StatusId', SearchValue: 1 }],
                    columns:[Vas.Resources.Labels["ContractNumber"],
                            Vas.Resources.Labels["Customer"] ,
                            Vas.Resources.Labels["State"], 
                            Vas.Resources.Labels["Product"],
                            Vas.Resources.Labels["Start"],
                            Vas.Resources.Labels["End"],
                            Vas.Resources.Labels["School"],
                            Vas.Resources.Labels["Street"],
                            Vas.Resources.Labels["HouseNumber"],
                            Vas.Resources.Labels["HouseNumberAddition"],
                            Vas.Resources.Labels["City"],
                            Vas.Resources.Labels["PLZ"],
                            Vas.Resources.Labels["Action"]],
                    keys:["ContractNumber", 
                            "CustomerName", 
                            "Status",
                            "TicketName", 
                            "DateFrom",
                            "DateTo",
                            "CustomerAbove",
                            "Street",
                            "HouseNumber",
                            "HouseNumberAddition",
                            "City",
                            "PostCode"],
                    Filter:true,
                    Action:false,
                    Delete:true,
                    CWidth:[100,120,70,120,100,100,150,150,70,70,100,70,45],
                    Search:true
                },()=>{
                    this.load(this.refs.table.PrepareSendData());
                });
            } else {
                this.refs.table.setState({
                    SearchParams:[{ Parameter: "StatusId", SearchValue: 10 }],
                    columns:[Vas.Resources.Labels["ContractNumber"],
                    Vas.Resources.Labels["Customer"] ,
                    Vas.Resources.Labels["State"], 
                    Vas.Resources.Labels["Product"],
                    Vas.Resources.Labels["Start"],
                    Vas.Resources.Labels["End"],
                    Vas.Resources.Labels["School"],
                    Vas.Resources.Labels["Street"],
                    Vas.Resources.Labels["HouseNumber"],
                    Vas.Resources.Labels["HouseNumberAddition"],
                    Vas.Resources.Labels["City"],
                    Vas.Resources.Labels["PLZ"]], 
                    keys:["ContractNumber", 
                        "CustomerName", 
                        "Status",
                        "TicketName", 
                        "DateFrom",
                        "DateTo",
                        "CustomerAbove",
                        "Street",
                        "HouseNumber",
                        "HouseNumberAddition",
                        "City",
                        "PostCode"],
                    Action:true,
                    Filter:false,
                    Delete:false,
                    CWidth:[100,120,70,120,100,100,150,150,70,70,100,70],
                    Search:true
                },()=>{
                    this.load(this.refs.table.PrepareSendData());
                });
            }
        }
    }
    
    load(sendData)
    {
        let statusId = $("#Filter").children("option:selected").val();

        if (this.state.ready === true){
            let sendDataArray = sendData.split('&');

            let sendDataString = "";

            if(sendDataArray[2] != undefined){

                if(statusId > -1){
                    sendDataString = sendDataArray[0] + "&" + sendDataArray[1] + "&StatusId=" + statusId + "&" + sendDataArray[2];
                } else {
                    sendDataString = sendDataArray[0] + "&" + sendDataArray[1] + "&" + sendDataArray[2];
                }
                
            } else {
                sendDataString = sendDataArray[0] + "&" + sendDataArray[1] + "&StatusId=" + statusId;
            }

            this.ContractsModel.GetContracts(sendDataString);

            $("#LoadingIcon").removeClass().addClass('loaderSmall');
        }
        
    }

    Cancel(event){
        let me = this;
        
        let id = $(event.target).parent().parent().parent().parent().parent().parent().parent("tr")[0].id;

        for (let i = 0; i < me.refs.table.state.Data.length; i++)
        {
            if (me.refs.table.state.Data[i].Id === id)
            {
                localStorage.setItem('contract',JSON.stringify(me.refs.table.state.Data[i]));
                break;
            }
        }

        Vas.GetView("ContractCancel",{ContractId : id},true);
    }

    AddContract(){
        this.Request.setErrorHandler(()=>{});
        
        this.PaymentsModel.GetPaymentsByCustomerId(this.CustomerId);
    }

    MultibleApprove(ids){
        $("#LoadingIcon").removeClass().addClass('loaderSmall');
        
        this.ContractsModel.SetRequest(this.Request);
        this.ContractsModel.ContractsChangeStatusBulk(ids,"",true,false);
    }

    render()
    {
        let rights = RoleConfiguration.getRoleConfig();
        
        let right = '';

        let width = '900px';

        if (this.role === "1"){
            if (rights[3]){
               right =  rights[3]; 
            }
        }
        if (this.role === "3" || this.role === "99"){
            if (rights[0]){
              right = rights[0];  
            }

            width='1500px';
        }
        
        if ((this.role === '3')||(this.role === '99')){
            
            if (this.state.Id !== "")
            {
                Vas.GetView("ContractCardContractData",{ Id:this.state.Id,CustomerId:this.state.CustomerId,CustomerName:this.state.CustomerName },true);
            }
        }

        let pagingTable = '';

        if (this.role === '1'){
            
            pagingTable = (<PagingTable
              SearchCol={"ContractNumber"}
              ErrorHandlingPage={(error)=>{Vas.ErrorHandling(error);}}
              ref="table"
              TableReference={this}
              DataBaseTable={"B2Vertraege"}
              Border={true}
              Selectable={false} 
              Start={this.state.Start}
              End={this.state.End}
              Limit={10}
              Count={this.state.Count}
              Data={this.state.Data}
              CSV={true}
              CSVTableName={Vas.Resources.Labels["Contracts"]} 
              CSVController={"/Contracts"}
              Token={localStorage.getItem('vas_token')}
              Delete={true}
              DeleteOnClick={(event)=>{this.Cancel(event);}}
              DeleteValue={1}
              DeleteId={"StatusId"}
              Right={right}
              LabelPage={Vas.Resources.Labels["Page"]}
              LabelOf={Vas.Resources.Labels["Of"]}
              LabelCountPerPage={Vas.Resources.Labels["CountPerPage"]}
              AppURL={Vas.ApplicationUrl}
              ApiURL={Vas.ApiUrl}
              ApiKey={Vas.ApiKey}
              FilterData={[{ Key:"-1", Display:Vas.Resources.Labels["All"] },
                            { Key:"1", Display:Vas.Resources.Labels["Active"] },
                            { Key:"2", Display:Vas.Resources.Labels["Canceled"] },
                            { Key:"10", Display:Vas.Resources.Labels["PendingApproval"] },
                            { Key:"3",Display:Vas.Resources.Labels["Loss"] } ,
                            { Key:"5",Display:Vas.Resources.Labels["Changed"] },
                            { Key:"6",Display:Vas.Resources.Labels["Deleted"] },
                            { Key:"7",Display:Vas.Resources.Labels["Expired"] },
                            { Key:"15",Display:Vas.Resources.Labels["Declined"] }
                        ]} 
              FilterColoumn={"StatusId"}
              FilterText={Vas.Resources.Labels["Filter"]}
              FilterDefault={Vas.Resources.Labels["Active"]}
              SelectFieldChooseText={Vas.Resources.Labels["PleaseChoose"]} 
              Actions={[{ String:Vas.Resources.Labels["Approve"], OnClick:(ids)=>{this.MultibleApprove(ids);} }]} 
              ActionLabel={[Vas.Resources.Labels["ActionConfirm"],Vas.Resources.Labels["ActionConfirm2"],Vas.Resources.Labels["ActionConfirm3"]]}
              LabelConfirm={Vas.Resources.Labels["Confirm"]}
              LabelCancel={Vas.Resources.Labels["Cancel"]}
              NewApi={true}
              RowOnClick={(id)=>{this.loadContract(id);}}
              columns={[Vas.Resources.Labels["ContractNumber"],
                        Vas.Resources.Labels["Customer"] ,
                        Vas.Resources.Labels["State"], 
                        Vas.Resources.Labels["Product"],
                        Vas.Resources.Labels["Start"],
                        Vas.Resources.Labels["End"],
                        Vas.Resources.Labels["Action"]]}
                Keys={["ContractNumber", 
                        "CustomerName", 
                        "Status",
                        "TicketName", 
                        "DateFrom",
                        "DateTo"]}/>);
            
        } else if (this.role === "3" || this.role === "99"){
            if (this.state.all === 'true'){

                pagingTable = (<PagingTable
                    SearchCol={"ContractNumber"}
                    ErrorHandlingPage={(error)=>{Vas.ErrorHandling(error);}}
                      ref="table"
                      TableReference={this}
                      DataBaseTable={"B2Vertraege"}
                      Border={true}
                      Selectable={false} 
                      Start={this.state.Start}
                      End={this.state.End}
                      Limit={10}
                      Count={this.state.Count}
                      Data={this.state.Data}
                      CSV={true}
                      CSVTableName={Vas.Resources.Labels["Contracts"]} 
                      CSVController={"/Contracts"}
                      Token={localStorage.getItem('vas_token')}
                      Delete={true}
                      DeleteOnClick={(event)=>{this.Cancel(event);}}
                      DeleteValue={1}
                      DeleteId={"StatusId"}
                      Right={right}
                      LabelPage={Vas.Resources.Labels["Page"]}
                      LabelOf={Vas.Resources.Labels["Of"]}
                      LabelCountPerPage={Vas.Resources.Labels["CountPerPage"]}
                      AppURL={Vas.ApplicationUrl}
                      ApiURL={Vas.ApiUrl}
                      ApiKey={Vas.ApiKey}
                      FilterData={[{ Key:"1", Display:Vas.Resources.Labels["Active"] },
                                   { Key:"10", Display:Vas.Resources.Labels["PendingApproval"] },
                                   { Key:"15",Display:Vas.Resources.Labels["Declined"] }
                                ]} 
                      FilterColoumn={"StatusId"}
                      FilterText={Vas.Resources.Labels["Filter"]}
                      FilterDefault={Vas.Resources.Labels["Active"]}
                      SelectFieldChooseText={Vas.Resources.Labels["PleaseChoose"]} 
                      Actions={[{ String:Vas.Resources.Labels["Approve"], OnClick:(ids)=>{this.MultibleApprove(ids);} }]} 
                      ActionLabel={[Vas.Resources.Labels["ActionConfirm"],Vas.Resources.Labels["ActionConfirm2"],Vas.Resources.Labels["ActionConfirm3"]]}
                      LabelConfirm={Vas.Resources.Labels["Confirm"]}
                      LabelCancel={Vas.Resources.Labels["Cancel"]}
                      NewApi={true}
                      RowOnClick={(id)=>{this.loadContract(id);}}
                      Columns={[Vas.Resources.Labels["ContractNumber"],
                            Vas.Resources.Labels["Customer"]]}
                      Keys={["ContractNumber", 
                              "CustomerName"]}
                      SearchLimit={7000}
                      ExtendShownResultsOnPage={true}
                      ShowAllOnOnePage={true}/>);
            } else {

                pagingTable = (<PagingTable
                    SearchCol={"ContractNumber"}
                    ErrorHandlingPage={(error)=>{Vas.ErrorHandling(error);}}
                      ref="table"
                      TableReference={this}
                      DataBaseTable={"B2Vertraege"}
                      Border={true}
                      Selectable={false} 
                      Start={this.state.Start}
                      End={this.state.End}
                      Limit={10}
                      Count={this.state.Count}
                      Data={this.state.Data}
                      CSV={true}
                      CSVTableName={Vas.Resources.Labels["Contracts"]} 
                      CSVController={"/Contracts"}
                      Token={localStorage.getItem('vas_token')}
                      Delete={true}
                      DeleteOnClick={(event)=>{this.Cancel(event);}}
                      DeleteValue={1}
                      DeleteId={"StatusId"}
                      Right={right}
                      LabelPage={Vas.Resources.Labels["Page"]}
                      LabelOf={Vas.Resources.Labels["Of"]}
                      LabelCountPerPage={Vas.Resources.Labels["CountPerPage"]}
                      AppURL={Vas.ApplicationUrl}
                      ApiURL={Vas.ApiUrl}
                      ApiKey={Vas.ApiKey}
                      FilterData={[{ Key:"1", Display:Vas.Resources.Labels["Active"] },
                                    { Key:"10", Display:Vas.Resources.Labels["PendingApproval"] }
                                ]} 
                      FilterColoumn={"StatusId"}
                      FilterText={Vas.Resources.Labels["Filter"]}
                      FilterDefault={Vas.Resources.Labels["Active"]}
                      SelectFieldChooseText={Vas.Resources.Labels["PleaseChoose"]} 
                      Actions={[{ String:Vas.Resources.Labels["Approve"], OnClick:(ids)=>{this.MultibleApprove(ids);} }]} 
                      ActionLabel={[Vas.Resources.Labels["ActionConfirm"],Vas.Resources.Labels["ActionConfirm2"],Vas.Resources.Labels["ActionConfirm3"]]}
                      LabelConfirm={Vas.Resources.Labels["Confirm"]}
                      LabelCancel={Vas.Resources.Labels["Cancel"]}
                      NewApi={true}
                      RowOnClick={(id)=>{this.loadContract(id);}}
                      Columns={[Vas.Resources.Labels["ContractNumber"],
                        Vas.Resources.Labels["Customer"]]}
                      Keys={["ContractNumber",
                          "CustomerName"]}
                        SearchLimit={7000}
                        ExtendShownResultsOnPage={true}
                        ShowAllOnOnePage={true}/>);
            }
        }

        return (
          <div 
            className={"form contractsForm"}
            style={{ width: width }}>
            <table>
              <thead>
                <tr>
                  <th style={{ width:'100%' }}></th>
                  <th><div 
                    id={"LoadingIcon"}
                    className={'hide'} ></div></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td >
                { pagingTable }
                  </td>
                </tr>
              </tbody>
            </table>
                
          </div> 
        );
    }
}
export default Contracts;
